module.exports = __webpack_public_path__ + "img/item-list3.fb5065bb.png";